import { Component, Input, inject, output, input } from '@angular/core';

import { IAgentCard } from '../../../models/agent.models';
import { FiltersConfig } from '@dataclouder/ngx-core';
import { AgentCardsAbstractService, CONVERSATION_AI_TOKEN } from '../../../models/conversation-ai.class';

@Component({
  selector: 'dc-chat-header',
  standalone: true,
  imports: [],
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
})
export class ChatHeaderComponent {
  private agentCardService = inject<AgentCardsAbstractService>(CONVERSATION_AI_TOKEN);

  readonly isAdmin = input<boolean>(false);
  @Input() alternativeConversation: IAgentCard[] = [];
  @Input() agentCard!: IAgentCard;

  readonly restartConversationEvent = output<IAgentCard | null>();
  readonly showInfoEvent = output<void>();
  readonly settingsClickEvent = output<void>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  restartConversation(conversation: IAgentCard | null = null): void {
    this.restartConversationEvent.emit(conversation);
  }

  showInfo(): void {
    this.showInfoEvent.emit();
  }

  settingsClick(): void {
    this.settingsClickEvent.emit();
  }

  public async changeConversationCard() {
    const response = prompt('¿Qué conversación quieres usar? Escribe el titulo ejemplo: word_reflection_level_1_base_es');
    if (response) {
      const filters: FiltersConfig = {
        filters: {
          title: { $regex: response },
        },
      };
      console.log('filters', filters);
      const conversationCards = await this.agentCardService.filterConversationCards(filters);
      console.log('conversationCards', conversationCards);
      this.alternativeConversation = conversationCards.rows;
    }
  }
}
